












































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import {AuthStore} from "@/modules/auth/store";
import {NotificationParams, NotificationReadStatus} from "@/modules/account";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import NotificationDetailCustomer from "@/modules/account/Notification/Detail/index.vue";

@Component({
    name: "NotificationCustomer",
    components: {NotificationDetailCustomer}
})
export default class extends mixins(CommonMixin) {
    PAGE_SIZE_OPTIONS = PAGE_SIZE_OPTIONS;
    NotificationReadStatus = NotificationReadStatus;
    idSelected = null;
    backgroundColor = {
        readed: '#d2d2d2',
        notYet: '#d40404'
    }
    async created() {
       await AuthStore.getListNotification(new NotificationParams());
       this.idSelected = this.getProp(this.listNotification, '[0].id', undefined);
    }

    seeDetail(val: any) {
        if (!val) return;
        this.idSelected = val.id;
        val.readStatus = NotificationReadStatus.Readed;
    }

    get listNotification () {
        return AuthStore.listNotification;
    }

    get meta() {
        return AuthStore.listNotificationMeta;
    }

    get quantityNotification() {
        return AuthStore.quantityNotify;
    }
    onChangePage(pagination: any) {
        AuthStore.getListNotification({ ...new NotificationParams(), page: pagination });
    }
}
